export default __webpack_public_path__ + "static/member-plant-1-2-cd1a408c4bbd1bb89715ac0343f1c808.png";